import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { getOneSystem } from '../../../api/system';

const useSystem = (
  systemId: string,
  options?: Omit<UseQueryOptions, 'queryKey' | 'queryFn'>
) => {
  return useQuery({
    queryKey: ['oneSystem', systemId],
    queryFn: () => getOneSystem(systemId),
    ...options,
  });
};

export default useSystem;
